export const percentageForProgressBar = (value: number, totalValue: number) => {
  let valuePercentage = (value * 100) / totalValue

  if (valuePercentage > 100) {
    valuePercentage = 100
  }

  return valuePercentage
}
